import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'

export function CustomDropdownPriceList({
  options = [],
  value = [],
  onSelect,
  label = 'Seleccione una opción*',
  getOptionLabel,
  getOptionValue,
  error,
  name = 'dropdownPriceList',
}) {
  const [showOptions, setShowOptions] = useState(false)

  const handleAdd = item => {
    const exists = value.some(
      selected =>
        getOptionValue(selected)?.toUpperCase() ===
        getOptionValue(item)?.toUpperCase()
    )
    if (!exists) {
      onSelect([item])
    }
    setShowOptions(false)
  }

  const handleRemove = item => {
    const newList = value.filter(
      selected => getOptionValue(selected) !== getOptionValue(item)
    )
    onSelect(newList)
  }

  return (
    <>
      <label htmlFor={name}>{label}</label>
      <div className="no-margin-nopadding generic-address-search-filter list-prices-component">
        <button
          type="button"
          className="generic-address-filter-content-list-price"
          onClick={() => setShowOptions(prev => !prev)}
          style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}
          data-testid={`btn-toggle-${name}`}>
          {value.length > 0 ? (
            value.map((item, index) => (
              <span
                key={getOptionValue(item) || index}
                className="generic-price-list-label-text"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: 8,
                  background: '#f0f0f0',
                  borderRadius: 4,
                  padding: '2px 8px',
                }}>
                {getOptionLabel(item)}
                <button
                  type="button"
                  style={{
                    border: 'none',
                    background: 'transparent',
                    marginLeft: 6,
                    cursor: 'pointer',
                  }}
                  onClick={e => {
                    e.stopPropagation()
                    handleRemove(item)
                  }}
                  data-testid={`btn-remove-${name}-${index}`}>
                  ✕
                </button>
              </span>
            ))
          ) : (
            <p className="generic-price-list-label-text-unselect">{label}</p>
          )}
          <FontAwesomeIcon
            icon={faChevronDown}
            className="generic-list-price-down-icon"
          />
        </button>

        <ul
          id={name}
          className={
            showOptions
              ? 'generic-address-filter-options ul-price-list ul-filter-option-multiple'
              : 'generic-address-filter-options-hidden'
          }
          onMouseLeave={() => setShowOptions(false)}>
          {options.map((item, index) => (
            <li
              key={getOptionValue(item)}
              className="customer-filter-option-multiple"
              onClick={() => handleAdd(item)}
              data-testid={`${name}-option-${index}`}>
              {getOptionLabel(item)}
            </li>
          ))}
        </ul>
      </div>
      {error && (
        <div className="input-feedback">
          <strong>{error}</strong>
        </div>
      )}
    </>
  )
}
